/**
 * @greymass/create-account v0.0.9
 * https://github.com/greymass/create-account
 *
 * @license
 * Copyright (c) 2021 FFF00 Agents AB & Greymass Inc. All Rights Reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 * 
 *  1. Redistribution of source code must retain the above copyright notice, this
 *     list of conditions and the following disclaimer.
 * 
 *  2. Redistribution in binary form must reproduce the above copyright notice,
 *     this list of conditions and the following disclaimer in the documentation
 *     and/or other materials provided with the distribution.
 * 
 *  3. Neither the name of the copyright holder nor the names of its contributors
 *     may be used to endorse or promote products derived from this software without
 *     specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * YOU ACKNOWLEDGE THAT THIS SOFTWARE IS NOT DESIGNED, LICENSED OR INTENDED FOR USE
 * IN THE DESIGN, CONSTRUCTION, OPERATION OR MAINTENANCE OF ANY MILITARY FACILITY.
 */
import { Name } from '@greymass/eosio';
import { ChainId } from 'eosio-signing-request';
import { detectReturnPath } from '@greymass/return-path';

class AccountCreator {
    constructor(options) {
        this.options = options;
        this.supportedChains = (options.supportedChains || []).map((id) => ChainId.from(id));
        if (options.scope) {
            this.scope = Name.from(options.scope);
        }
        this.creationServiceUrl = options.creationServiceUrl || 'https://create.anchor.link';
        this.returnUrl = options.returnUrl || detectReturnPath();
    }
    async createAccount() {
        const qs = new URLSearchParams();
        qs.set('return_url', this.returnUrl);
        if (this.supportedChains.length > 0) {
            qs.set('supported_chains', this.supportedChains.map(String).join(','));
        }
        if (this.scope) {
            qs.set('scope', String(this.scope));
        }
        const url = `${this.creationServiceUrl}/create?${qs}`;
        this.popupWindow = window.open(url, 'targetWindow', `toolbar=no,
            location=no,
            status=no,
            menubar=no,
            scrollbars=yes,
            resizable=yes,
            width=400,
            height=600`);
        return new Promise((resolve, reject) => {
            const listener = (event) => {
                if (event.origin === this.creationServiceUrl) {
                    window.removeEventListener('message', listener);
                    this.closeDialog();
                    if (event.data.error) {
                        reject(new Error(event.data.error));
                    }
                    else {
                        resolve(event.data);
                    }
                }
            };
            window.addEventListener('message', listener);
            this.popupStatusInterval = setInterval(() => {
                if (this.popupWindow && this.popupWindow.closed) {
                    this.closeDialog();
                    reject(new Error('Popup window closed'));
                }
            }, 500);
        });
    }
    closeDialog() {
        this.popupWindow?.close();
        this.cleanup();
    }
    cleanup() {
        this.popupStatusInterval && clearInterval(this.popupStatusInterval);
        this.popupStatusInterval = undefined;
        this.popupWindow = undefined;
    }
}

export { AccountCreator };
//# sourceMappingURL=create-account.m.js.map
